import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

// ----------------------------------------------------------------------

LogoFull.propTypes = {
  className: PropTypes.string
};

function LogoFull({ className, ...other }) {
  return (
    <Box
      component="img"
      alt="logo"
      src="/static/brand/logo_full.png"
      height={50}
      className={className}
      {...other}
    />
  );
}

export default LogoFull;
